/**
 * `useSuperadminMode` — React subscriber for the sessionStorage-backed
 * toggle owned by `auth/superadminMode.ts`. Wraps the module's
 * listener API with `useSyncExternalStore` so toggle flips re-render
 * subscribing components.
 *
 * Read-only — components that need to *set* the toggle import
 * `setSuperadminMode` from the module directly. That mirrors the
 * authClient pattern (read via hook, mutate via imperative call) and
 * keeps the hook surface minimal.
 */
import { useSyncExternalStore } from 'react'
import {
  getSuperadminMode,
  subscribeSuperadminMode,
} from '@/auth/superadminMode'

export function useSuperadminMode(): boolean {
  return useSyncExternalStore(
    subscribeSuperadminMode,
    getSuperadminMode,
    // Server snapshot — SSR returns OFF. We don't SSR today (Vite SPA),
    // but useSyncExternalStore's contract requires a third argument
    // when the store can be sampled before hydration.
    () => false,
  )
}
